import { POINTS } from './constants';
import React from 'react';

export const getAppliedFilters = (state) => {
	const appliedFilters = state.filter((filter) => filter.isActive);
	return appliedFilters.length
		? appliedFilters.map((filter) => filter.value)
		: ['all'];
};

export const getMedianValue = (data, appliedFilters) => {
	const filter = appliedFilters[0];
	if (!data[filter]) return null;

	return Math.round(data[filter].median * 4) / 4;
};

export const getDeviationValue = (
	point,
	data,
	appliedFilters,
	maxValue,
	minValue,
) => {
	const filter = appliedFilters[0];
	const max = maxValue > minValue ? maxValue : minValue;

	if (!data[filter] || !data[filter].standardDeviation) return null;
	const deviation = Math.round(data[filter].standardDeviation * 4) / 4;
	const median = Math.round(data[filter].median * 4) / 4;

	if (point === POINTS.x1) {
		const x1 = median - deviation;
		return x1 > 0 ? x1 : 0;
	}

	if (point === POINTS.x2) {
		const x2 = median + deviation + 0.25;
		return x2 <= max ? x2 : max;
	}

	if (point === POINTS.x11) {
		const x11 = median - deviation * 2;
		return x11 > 0 ? x11 : 0;
	}

	if (point === POINTS.x22) {
		const x22 = median + deviation * 2 + 0.25;
		return x22 <= max ? x22 : max;
	}
};

export const renderMedianLabel = (label) => {
	const { viewBox } = label;

	const width = 42;
	const topOffset = 14;
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='42'
			height='14'
			viewBox='0 0 42 14'
			x={viewBox.x - width / 2}
			y={viewBox.y + topOffset}
		>
			<g fill='none' fillRule='evenodd'>
				<rect width='42' height='14' fill='#333437' rx='7' />
				<path
					fill='#FFF'
					fillRule='nonzero'
					d='M8.778 9.911L6.914 4.488H6.88c.05.805.075 1.56.075 2.265v3.158H6V3.418h1.481l1.785 5.165h.026l1.837-5.165h1.486V9.91h-1.011V6.7c0-.323.008-.743.024-1.262l.033-.82a2.84 2.84 0 0 1 .009-.121h-.035L9.705 9.91h-.927zM16.32 10c-.756 0-1.347-.223-1.773-.668-.427-.446-.64-1.06-.64-1.842 0-.802.198-1.433.593-1.892.396-.459.94-.688 1.631-.688.642 0 1.149.197 1.52.59.373.394.56.936.56 1.626v.564h-3.24c.014.477.142.844.382 1.1.24.256.579.384 1.015.384.288 0 .555-.028.803-.082.247-.055.513-.146.797-.273v.848a3.148 3.148 0 0 1-.764.257c-.258.05-.553.076-.884.076zm-.189-4.3c-.328 0-.591.106-.789.316-.198.21-.316.517-.354.92h2.207c-.006-.406-.103-.714-.29-.922-.188-.21-.446-.313-.774-.313zm4.892 4.3c-.606 0-1.08-.222-1.42-.666-.34-.444-.51-1.068-.51-1.87 0-.806.173-1.433.517-1.881.344-.449.821-.673 1.43-.673.64 0 1.126.238 1.46.715h.053l-.048-.387a4.526 4.526 0 0 1-.027-.448V3h1.037v6.911h-.808l-.18-.644h-.049c-.331.489-.816.733-1.455.733zm.277-.844c.425 0 .734-.12.927-.362.194-.241.293-.633.3-1.175v-.146c0-.62-.1-1.059-.3-1.32-.199-.26-.51-.39-.936-.39a.947.947 0 0 0-.84.446c-.196.298-.294.722-.294 1.273 0 .544.095.96.286 1.245.19.286.476.43.857.43zm4.725.755h-1.033V5h1.033V9.91zm-1.094-6.214c0-.186.05-.33.151-.43.101-.101.246-.152.433-.152.182 0 .323.05.424.151.101.101.152.245.152.431a.57.57 0 0 1-.152.42c-.1.102-.242.153-.424.153-.187 0-.332-.05-.433-.153a.57.57 0 0 1-.151-.42zm5.612 6.214l-.206-.684h-.035c-.235.3-.47.503-.708.61-.237.109-.542.163-.914.163-.478 0-.85-.13-1.119-.39-.268-.261-.402-.63-.402-1.107 0-.506.186-.888.558-1.146.372-.257.94-.398 1.701-.422l.84-.026v-.262c0-.314-.073-.549-.218-.704-.145-.156-.37-.234-.675-.234-.249 0-.487.037-.716.111a5.373 5.373 0 0 0-.66.262l-.333-.746a3.57 3.57 0 0 1 .865-.317c.314-.073.61-.11.888-.11.619 0 1.085.137 1.4.41.315.272.473.7.473 1.283v3.31h-.739zm-1.538-.71c.375 0 .676-.106.903-.318.227-.212.34-.509.34-.89v-.427l-.623.027c-.487.017-.84.1-1.062.246-.221.147-.332.371-.332.673 0 .22.065.389.194.509s.322.18.58.18zM37 9.91h-1.037v-3.02c0-.38-.076-.662-.227-.848-.15-.187-.39-.28-.718-.28-.437 0-.756.13-.958.39-.203.261-.304.698-.304 1.31v2.448h-1.033V5h.81l.144.644h.053c.146-.234.354-.415.624-.542.27-.127.568-.191.897-.191 1.166 0 1.749.6 1.749 1.799V9.91z'
				/>
			</g>
		</svg>
	);
};

export const renderDeviationLabel = (label) => {
	const { viewBox } = label;

	const minWidth = 38;
	const posMin1 =
		viewBox.width > 53
			? viewBox.x - 4
			: viewBox.x + viewBox.width / 2 - minWidth + 4;

	const posPlus1 =
		viewBox.width > 53
			? viewBox.x + viewBox.width - 4
			: viewBox.x + viewBox.width / 2 + minWidth - 12;

	const posMin2 =
		viewBox.width > 53
			? viewBox.x - viewBox.width / 2 - 4
			: viewBox.x + viewBox.width / 2 - minWidth - 7;

	const posPlus2 =
		viewBox.width > 53
			? viewBox.x + viewBox.width * 1.5 - 4
			: viewBox.x + viewBox.width / 2 + minWidth;

	return (
		<text x={viewBox.x} y={viewBox.y - 24} fill='#999999'>
			<tspan
				x={viewBox.x + viewBox.width / 2 - minWidth / 2}
				dy='1em'
				width='3'
			>
				Standard
			</tspan>
			<tspan x={viewBox.x + viewBox.width / 2 - minWidth / 2} dy='1em'>
				deviation
			</tspan>
			<tspan x={posMin1} y={viewBox.y - 20} dy='1em'>
				-1
			</tspan>
			<tspan x={posPlus1} y={viewBox.y - 20} dy='1em'>
				+1
			</tspan>
			<tspan x={posMin2} y={viewBox.y - 20} dy='1em'>
				-2
			</tspan>
			<tspan x={posPlus2} y={viewBox.y - 20} dy='1em'>
				+2
			</tspan>
		</text>
	);
};

export const getMax = (state = {}) => {
	const arr = Object.keys(state).map((key) => parseFloat(key));
	return Math.max(...arr);
};

// TODO: Need to refactor this logic
export const getFilters = (filters, params) => {
	if (params.search && params.search.concentrator_model_id.length > 0) {
		const modelId = params.search.concentrator_model_id[0];
		return (filters = filters.filter((flowSetting) => {
			return flowSetting.devices.indexOf(modelId) >= 0;
		}));
	}

	return filters;
};

export const sortKeys = (keys) => {
	const sortedArray = [...keys];

	return sortedArray.sort((keyA, keyB) => {
		if (isNaN(keyA)) {
			return -1;
		} else {
			if (keyA > keyB) return +1;
			if (keyA < keyB) return -1;
			return 0;
		}
	});
};
